import React from 'react';
import { useGym } from './GymContext';

export default function TermsContent() {
  // Pull the dynamic data from our Global Context
  const { brand } = useGym();

  // Safety check: if brand isn't loaded yet, show nothing or a loader
  if (!brand) return null;

  return (
    <div style={{ textAlign: 'left' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Terms &amp; Conditions</h2>
      
      <p className="if-terms-effective">
        <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
      </p>

      <p>
        These Terms &amp; Conditions (the <strong>“Agreement”</strong>) govern your access to and
        use of the facilities, premises, classes, training areas, equipment, programs,
        services, events, and any related communications offered by{" "}
        <strong>{brand.siteName}</strong> (the <strong>“Gym,” “we,” “us,”</strong> or{" "}
        <strong>“our”</strong>).
      </p>

      <p>
        By checking the box indicating you agree to these Terms &amp; Conditions, you confirm that
        you have read, understood, and agree to be bound by this Agreement. You further acknowledge
        that this Agreement contains important disclosures regarding (i) assumption of risk,
        (ii) release of liability, (iii) safety and facility rules, (iv) hygiene and health
        requirements, and (v) consent to receive communications including automated email and/or
        text messages.
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>1. Definitions</h3>
      <p>
        <strong>“Participant,” “you,”</strong> or <strong>“your”</strong> means the individual
        completing this intake form and participating in any activity at the Gym.
      </p>
      <p>
        <strong>“Activities”</strong> include, without limitation, strength training, conditioning,
        group fitness, martial arts training (including Brazilian Jiu‑Jitsu / grappling), sparring,
        drills, open mat, stretching, use of weights and machines, classes, instruction, events,
        demonstrations, and any related physical activity on or off the premises under the Gym’s
        direction or sponsorship.
      </p>
      <p>
        <strong>“Premises”</strong> includes the Gym facility located at <strong>{brand.addressLine}</strong>,
        including parking areas, entrances, common areas, washrooms, change rooms, training floors,
        and any associated or temporary locations used for Gym Activities.
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>2. Eligibility, Authority, and Accurate Information</h3>
      <p>
        You represent that you are at least the age of majority in your jurisdiction (or, if not,
        that a parent or legal guardian has reviewed and accepted this Agreement on your behalf).
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>3. Free Trial Terms</h3>
      <p>
        The Gym may offer a free trial (the <strong>“Trial”</strong>) for a limited duration (e.g., seven (7) days) from the date of activation.
      </p>
      <p>
        The Trial is intended for new participants and may be limited to one Trial per person. The Gym reserves the right to deny or discontinue a Trial where the Gym
        reasonably suspects fraud, abuse, or policy violation.
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>6. Release of Liability and Waiver of Claims</h3>
      <p>
        You agree that this release is intended to be as broad and inclusive as permitted by the
        laws of <strong>Ontario, Canada</strong>, and if any portion is held invalid, the
        remaining portions shall remain in full force and effect.
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>11. Photos, Video, and Likeness</h3>
      <p>
        The Gym may take photos or videos for marketing or training purposes; if you do not wish to appear in marketing content, notify staff in writing at{" "}
        <strong>{brand.adminEmail}</strong>.
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>12. Communications Consent (Email &amp; Text)</h3>
      <p>
        <strong>Opt-out.</strong> You can opt out of SMS by replying <strong>STOP</strong>. You can opt out of marketing emails by using
        an unsubscribe link (where provided) or contacting the Gym at <strong>{brand.adminEmail}</strong>.
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>13. Privacy and Data Handling</h3>
      <p>
        You may request access, correction, or deletion of your data by contacting <strong>{brand.adminEmail}</strong>.
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>15. Governing Law; Dispute Resolution</h3>
      <p>
        This Agreement shall be governed by the laws of <strong>Ontario</strong> and the
        federal laws of <strong>Canada</strong>. Any dispute shall be brought in the courts located in 
        <strong> {brand.addressLine.includes("Maple") ? "Vaughan" : "Richmond Hill"}</strong>.
      </p>

      <h3 style={{ textAlign: 'center', marginTop: '25px' }}>17. Acknowledgement and Electronic Acceptance</h3>
      <p>
        By checking “I agree,” you acknowledge that you have read this Agreement, understand its
        terms and voluntarily agree to be bound by it.
      </p>

      <p className="if-terms-end" style={{ marginTop: '30px', textAlign: 'center', borderTop: '1px solid #eee', paddingTop: '20px' }}>
        <strong>Contact:</strong> {brand.adminEmail} • {brand.phone} • {brand.addressLine}
      </p>
    </div>
  );
}